import { Collapse } from "antd";
import { useSelect, useDiagram } from "../../../hooks";
import Empty from "../Empty";
import SearchBar from "./SearchBar";
import RelationshipInfo from "./RelationshipInfo";
import { ObjectType } from "../../../data/constants";
import { useTranslation } from "react-i18next";
import emptyImage from "assets/svg/emptyImg.svg";
import EmptyComponent from "components/EmptyComponent";


export default function RelationshipsTab() {
  const { relationships } = useDiagram();
  const { selectedElement, setSelectedElement } = useSelect();
  const { t } = useTranslation();

  return (
    <>
      <SearchBar />
      {relationships.length <= 0 ? (
        <EmptyComponent
          image={emptyImage}
          description="拖动以连接字段并形成关系！"
        />
      ) : (
        <Collapse
          activeKey={
            selectedElement.open &&
            selectedElement.element === ObjectType.RELATIONSHIP
              ? `${selectedElement.id}`
              : ""
          }
          onChange={(k) =>
            setSelectedElement((prev) => ({
              ...prev,
              open: true,
              id: parseInt(k),
              element: ObjectType.RELATIONSHIP,
            }))
          }
          accordion
          items={relationships.map((r) => ({
            key: `${r.id}`,
            label: (
              <div className="overflow-hidden text-ellipsis whitespace-nowrap">
                {r.name}
              </div>
            ),
            children: <RelationshipInfo data={r} />,
          }))}
        />
      )}
    </>
  );
}
